import RestService from './RestService';

class Builds extends RestService {
    constructor() {
        super('/builds');
    }
}

export default Builds;
